<!-- <app-navbar></app-navbar> -->

<div class="container">
    <br />
    <div class="row g-0">
        <div class="col-lg-2">
            <img src="assets/images/LogoHCD2.jpg " class="img-thumbnail" alt="LogoCamaraDiptuados" />
        </div>
        <div class="col-lg-10">
            <br />
            <br />
            <h2 style="text-align: right">
                Diputadas y diputados que remitieron carta de intención para participar en el proceso electoral federal
                2020-2021 para su elección consecutiva.
            </h2>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="table-responsive">
            <table class="table">
                <thead class="table-dark">
                    <tr>
                        <th class="enc_centrado" scope="col">N°</th>
                        <th class="enc_centrado" scope="col">Diputada / Diputado</th>
                        <th class="enc_centrado" scope="col">Grupo Parlamentario</th>
                        <th class="enc_centrado" scope="col">Entidad federativa</th>
                        <th class="enc_centrado" scope="col">Distrito / Circunscripción</th>
                        <th class="enc_centrado" scope="col">Tipo de elección</th>
                        <th class="enc_centrado" scope="col">Fecha de recepción</th>
                        <th class="enc_centrado" scope="col">En funciones</th>
                        <!-- <th class="enc_centrado" scope="col">Folio</th> -->
                        <th class="enc_centrado" scope="col">Carta</th>
                    </tr>
                </thead>
                <tbody *ngFor="let c of contendientes">
                    <tr>
                        <td>{{ c.Numero }}</td>
                        <td>{{ c.NombreDiputado }}</td>
                        <td>{{ c.GrupoParlamentario }}</td>
                        <td>{{ c.EntidadFederativa }}</td>
                        <td>{{ c.DistritoCircuns }}</td>
                        <td>{{ c.TipoEleccion }}</td>
                        <td>{{ c.FechaRecepcion | date: "dd 'de' MMMM 'del' yyyy" }}</td>
                        <td>{{ c.EnFunciones }}</td>
                        <!-- <td>{{ c.Folio }}</td> -->
                        <td>
                            <button type="button" class="btn btn-success" *ngIf="c.Enlace !== 0; else noFiles"
                                (click)="downloadBase64File(c)">
                                Descargar
                            </button>
                            <ng-template #noFiles>
                        <td></td>
                        </ng-template>
                        </td>
                    </tr>
                    <tr *ngIf="c.Notas !== null && c.Notas">
                        <td colspan="12">
                            <table class="table">
                                <thead class="table-light">
                                    <tr>
                                        <td><b> Notas:</b> {{ c.Notas }}</td>
                                    </tr>
                                </thead>
                                <!-- <tbody>
                              <tr>
                                  <td></td>
                              </tr>
                          </tbody> -->
                            </table>
                        </td>
                    </tr>
                </tbody>
                <ng-template #loadingFiles>Cargando...</ng-template>
            </table>
        </div>
    </div>
</div>